import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { About } from "./pages/about";
import { Home } from "./pages/home";
import { 
  AuthProvider, 
  PublicSettingsProvider, 
  GalleryProvider, 
  ErrorBoundary, 
  GlobalStyle,
  configureAmplify 
} from "./shared";

// Configure AWS Amplify for public SPA
configureAmplify();

// Lazy load gallery components to reduce initial bundle size
const GalleryItem = React.lazy(() => import("./pages/gallery").then(module => ({ default: module.GalleryItem })));

// Import shared components
import { LoadingSpinner } from "./shared";

// Wrapper component for lazy-loaded routes
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <React.Suspense fallback={<LoadingSpinner />}>
    {children}
  </React.Suspense>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/gallery/:index",
    element: (
      <LazyWrapper>
        <GalleryItem />
      </LazyWrapper>
    ),
  },
]);

const container = document.getElementById("root");
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <GlobalStyle />
      <AuthProvider>
        <PublicSettingsProvider>
          <GalleryProvider>
            <RouterProvider router={router} />
          </GalleryProvider>
        </PublicSettingsProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
